import { Img } from "components";
// import TextArea from "../components/TextArea";
// import { useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useSpotlight } from 'react-spotlight-tour';
// import { useSpotlight } from "../components/SpotLight";
// import BhashaniVideo from "../components/BhashaniVideo";
// import CommunicationModal from "../components/CommunicationModal";
import Stepper from "../components/Stepper";
import AvatarVideo from "../components/AvatarVideo";
import Wrapper from "../components/Wrapper";
import { useState } from "react";

// const customStylesRefer = {
//     content: {
//         top: "50%",
//         left: "50%",
//         right: "auto",
//         bottom: "auto",
//         marginRight: "-50%",
//         transform: "translate(-50%, -50%)",
//         width: "40rem", // Adjusted for responsiveness
//         maxWidth: "90%", // Added to maintain a max width
//         minHeight: "6rem",
//         borderRadius: "1em",
//         boxShadow: "0px 16px 32px 4px rgba(0, 0, 0, 0.15)",
//         padding: "10px 0px",
//         border: "0px",
//     },
//     overlay: {
//         background: "rgba(0, 0, 0, 0.4)",
//         zIndex: "999",
//     },
//     "@media (min-width: 768px)": {
//         content: {
//             width: "75%", // Adjusted for tablet view
//         },
//     },
//     "@media (min-width: 1024px)": {
//         content: {
//             width: "55rem", // Original width for desktop view
//         },
//     },
// };

const videoLinks = [
    { url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/comm-made-easy.mp4" },
    { url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/comm-solution.mp4" }
    // {url: "https://soomuch.blob.core.windows.net/data-soomuch/WebsiteContent/seralynne/intro.mp4?id=1"},
    // {url: "https://soomuch.blob.core.windows.net/data-soomuch/WebsiteContent/seralynne/intro.mp4?id=2"}
]

const CommPage2 = () => {
    const [state, setState] = useState("poor");
    // const navigate = useNavigate();
    // const videoRef = useRef(null);

    // const step1Ref = useSpotlight("");
    // const step2Ref = useSpotlight("");
    // const step3Ref = useSpotlight("");

    return (
        <Wrapper
            title={"Communications Made Easy"}
            description="🚫 Say NO to outdated methods that cause delays, confusion, and lost opportunities."
            descriptionSize="text-[2.5vh]"
            videoLinks={state === "poor" ? [videoLinks?.[0]] : [videoLinks?.[1]]}
            body={<>
                <div className="font-inter grid grid-cols-4 gap-x-6 gap-y-2 w-full">
                    {/* <div className="col-span-4 text-center">
                        <h2 className="text-smd_blue-dark font-manropeB text-[4vh]">Poor Communication Could Cost Your School Up To  ₹25 Lakhs</h2>
                    </div> */}
                    <div className="col-span-4 flex justify-center">
                        <div className="grid grid-cols-2 items-center bg-smd_white-normal border border-smd_blue-normal rounded-full p-1 w-fit">
                            <button type="button" onClick={() => setState("poor")} className={`text-[2.5vh] w-full ${state === "poor" ? "bg-smd_blue-normal text-[white]" : "bg-smd_white-normal text-smd_blue-normal"} rounded-full py-[1.5vh] px-8`}>
                                Poor Communication
                            </button>
                            <button type="button" onClick={() => setState("solution")} className={`text-[2.5vh] w-full ${state === "solution" ? "bg-smd_blue-normal text-[white]" : "bg-smd_white-normal text-smd_blue-normal"} rounded-full py-[1.5vh] px-8`}>
                                Solution
                            </button>
                        </div>
                    </div>
                    {state === "poor" ? <>
                    <div className="bg-[white] rounded-2xl p-[1.5vh] drop-shadow-lg text-[#081B34] space-y-2">
                        <Img src="images/soomuch-demo/SendOutMessage.svg" className="w-full" />
                        <p className="text-smd_blue-normal text-[2.2vh] font-manropeB">Step 1: You Send Out Important SMS Updates</p>
                        <div className="text-[1.9vh] space-y-2">
                            <p className=" font-manropeSB text-[black] tracking-wide">Imagine this</p>
                            <p className="">You send 500 SMS to parents about attendance or events. But here’s the problem...</p>
                            <p className=" font-manropeSB text-[black] tracking-wide">But here’s the problem...</p>
                        </div>
                    </div>
                    <div className="bg-[white] rounded-2xl p-[1.5vh] drop-shadow-lg text-[#081B34] space-y-2">
                        <Img src="images/soomuch-demo/Only100Percent.svg" className="w-full" />
                        <p className="text-smd_blue-normal text-[2.2vh] font-manropeB">Step 2: Only 100 Parents Understand Your Message</p>
                        <div className="text-[1.9vh] space-y-2">
                            <p>In India, only <span className=" font-manropeSB text-[black] tracking-wide">20%</span> are comfortable reading English. <span className=" font-manropeSB text-[black]">400</span> parents miss your message.</p>
                        </div>
                    </div>
                    <div className="bg-[white] rounded-2xl p-[1.5vh] drop-shadow-lg text-[#081B34] space-y-2">
                        <Img src="images/soomuch-demo/SmsNeverReach.svg" className="w-full" />
                        <p className="text-smd_blue-normal text-[2.2vh] font-manropeB">Step 3: SMS Is Often Ignored or Never Reaches</p>
                        <div className="text-[1.9vh] space-y-2">
                            <p className="">Even for those who can read English, delivery issues stack up</p>
                            <p className="">→ Poor signal or buried under spam</p>
                            <p className="">→ Phones are off/silent</p>
                        </div>
                    </div>
                    <div className="bg-[white] rounded-2xl p-[1.5vh] drop-shadow-lg text-[#081B34] space-y-2">
                        <Img src="images/soomuch-demo/ParentFeel.svg" className="w-full" />
                        <p className="text-smd_blue-normal text-[2.2vh] font-manropeB">Step 4: Parents Feel Disconnected & Leave</p>
                        <div className="text-[1.9vh] space-y-2">
                            <p>If <span className="text-[black] font-manropeSB tracking-wide">100 students</span> leave at ₹25,000/year, that’s a <span className=" font-manropeSB tracking-wide">₹25 lakh loss</span>, just from failed communication.</p>
                        </div>
                    </div>
                    </> :   <>
                    <div className="bg-[white] rounded-2xl p-[1.5vh] drop-shadow-lg text-[#081B34] space-y-2">
                        <Img src="images/soomuch-demo/RegionalLanguage.svg" className="w-full" />
                        <p className="text-smd_blue-normal text-[2.5vh] font-manropeB">Regional Language Support </p>
                        <div className="text-[2.2vh] space-y-2">
                            <p> Our automated IVR system delivers messages in each parent's preferred language - breaking all communication barriers.</p>
                        </div>
                    </div>
                    <div className="bg-[white] rounded-2xl p-[1.5vh] drop-shadow-lg text-[#081B34] space-y-2">
                        <Img src="images/soomuch-demo/Instant247.svg" className="w-full" />
                        <p className="text-smd_blue-normal text-[2.5vh] font-manropeB">Instant 24/7 Updates</p>
                        <div className="text-[2.2vh] space-y-2">
                            <p>Parents receive real-time alerts, day or night, keeping them always informed.</p>
                        </div>
                    </div>
                    <div className="bg-[white] rounded-2xl p-[1.5vh] drop-shadow-lg text-[#081B34] space-y-2">
                        <Img src="images/soomuch-demo/AutomatedCalls.svg" className="w-full" />
                        <p className="text-smd_blue-normal text-[2.5vh] font-manropeB">Reliable Automated Calls</p>
                        <div className="text-[2.2vh] space-y-2">
                            <p>Unlike SMS (which <span className="text-[black] font-manropeSB tracking-wide">fails 20%</span> of the time), our automated calls <span className="text-[black] font-manropeSB tracking-wide">ensure 100% reach.</span></p>
                        </div>
                    </div>
                    <div className="bg-[white] rounded-2xl p-[1.5vh] drop-shadow-lg text-[#081B34] space-y-2">
                        <Img src="images/soomuch-demo/StudentAlerts.svg" className="w-full" />
                        <p className="text-smd_blue-normal text-[2.5vh] font-manropeB">Personalized Student Alerts</p>
                        <div className="text-[2.2vh] space-y-2">
                            <p>From attendance to exams, PTMs to fee reminders - every update is customized and timely.</p>
                        </div>
                    </div>
                    </>}
                </div>
            </>}
        />
        // <div className="flex justify-center min-h-screen bg-[url(/public/images/soomuch-demo/background.svg)] bg-no-repeat bg-cover bg-center">
        //     <div className="container font-manrope p-7 flex flex-col justify-between w-full">
        //         <div className="flex">
        //             <div className="grid grid-cols-12 gap-4 w-full">
        //                 <div className="col-span-2"><Img src="images/soomuch-demo/logo.svg" /></div>
        //                 <div className="text-center self-end space-y-2 col-span-8">
        //                     <h1 className="font-raveo text-smd_blue-normal text-4xl font-[1000] leading-[120%] tracking-[-1%]">Communications Made Easy</h1>
        //                     <p className="text-sm">🚫 Say NO to outdated methods that cause delays, confusion, and lost opportunities.</p>
        //                 </div>
        //                 <div className="flex justify-end col-span-2">
        //                     <AvatarVideo videoLinks={videoLinks} />
        //                 </div>
        //             </div>
        //         </div>
        //         <div className="grid grid-cols-4 gap-6 w-full">
        //                 <div className="col-span-4 text-center">
        //                     <h2 className="text-smd_blue-dark font-manropeSB text-2xl">Poor Communication Could Cost Your School Up To  ₹25 Lakhs</h2>
        //                 </div>
        //                 <div className="bg-smd_white-normal rounded-2xl p-4 text-[#081B34]">
        //                     <p className="text-smd_blue-normal text-lg font-manropeSB">Step 1: You Send Out Important SMS Updates</p>
        //                     <div className="mt-2 space-y-1">
        //                         <p className="text-sm font-manropeSB tracking-wide">Imagine this</p>
        //                         <p className="text-sm">You send 500 SMS to parents about attendance or events. But here’s the problem...</p>
        //                         <p className="text-sm font-manropeSB tracking-wide">But here’s the problem...</p>
        //                     </div>
        //                 </div>
        //                 <div className="bg-smd_white-normal rounded-2xl p-4 text-[#081B34]">
        //                     <p className="text-smd_blue-normal text-lg font-manropeSB">Step 2: Only 100 Parents Understand Your Message</p>
        //                     <div className="mt-2">
        //                         <p className="text-sm">In India, only <span className="text-sm font-manropeSB tracking-wide">20%</span> are comfortable <br /> reading English. <span className="text-sm font-manropeSB">400</span> parents miss your <br /> message.</p>
        //                     </div>
        //                 </div>
        //                 <div className="bg-smd_white-normal rounded-2xl p-4 text-[#081B34]">
        //                     <p className="text-smd_blue-normal text-lg font-manropeSB">Step 3: SMS Is Often Ignored or Never Reaches</p>
        //                     <div className="mt-2 space-y-2">
        //                         <p className="text-sm">Even for those who can read English, delivery issues stack up</p>
        //                         <p className="text-sm">→ Poor signal or buried under spam</p>
        //                         <p className="text-sm">→ Phones are off/silent</p>
        //                     </div>
        //                 </div>
        //                 <div className="bg-smd_white-normal rounded-2xl p-4 text-[#081B34]">
        //                     <p className="text-smd_blue-normal text-lg font-manropeSB"> Step 4: Parents Feel Disconnected & Leave</p>
        //                     <div className="mt-2">
        //                         <p className="text-sm">If <span className="text-sm font-manropeSB tracking-wide">100 students</span> leave at ₹25,000/year, that’s a <span className="text-sm font-manropeSB tracking-wide">₹25 lakh loss</span>, just from failed communication.</p>
        //                     </div>
        //                 </div>
        //             </div>
        //             <div className="flex justify-center">
        //                 <div className="w-fit bg-smd_white-normal border-2 border-smd_blue-normal rounded-3xl py-4 px-8">
        //                     <p className="text-smd_blue-normal text-lg font-manropeSB">The Solution — Speak Their Language</p>
        //                 </div>
        //             </div>
        //             <Stepper />
        //     </div>
        // </div>
    );
}

export default CommPage2;